export default "__VITE_ASSET__BMjH1caB__"